const PREFIX = '__seguno-EVENT-ORDER-';

export default {
	CONVERSION: `${PREFIX}CONVERSION`
};
